/* eslint-disable @typescript-eslint/no-extraneous-class */
import { get } from 'aws-amplify/api'
import { environment } from '../environment'

export interface PartNumber {
  partnumber: string
  assets?: string[]
  harnesses?: string[]
  manuals?: string[]
  lastUpdatedBy?: string[]
}

class PartNumberServiceInstance {
  async getPartNumber (
    partnumber: string | undefined
  ): Promise<PartNumber | undefined> {
    if (partnumber === undefined) {
      return undefined
    }
    try {
      const encodedPartNumber = partnumber
        .replace(/\(/g, '%2528')
        .replace(/\)/g, '%2529')
      const response = await get({
        apiName: environment.apiName,
        path: `${environment.apiPaths.partnumber}/${encodedPartNumber}`
      }).response
      return (await response.body.json() as unknown as PartNumber)
    } catch (error: any) {
      if (error.response?.statusCode !== 404) { console.error('Error fetching part number', error) }
      return undefined
    }
  }
}

class PartNumberServiceSingleton {
  private static instance: PartNumberServiceInstance | null = null

  static getInstance (): PartNumberServiceInstance {
    if (PartNumberServiceSingleton.instance === null) {
      PartNumberServiceSingleton.instance = new PartNumberServiceInstance()
    }
    return PartNumberServiceSingleton.instance
  }
}

export const partNumberService = PartNumberServiceSingleton.getInstance()
